import {ConsumerProductsIndexRequest} from "@/core/http/resources/ConsumerProductResource";
import {consumerProductApi} from "@/container";
import useSwr from "@/core/composables/swr/useSwr";

/**
 * Composable to fetch consumer prescriptors.
 *
 * @param consumerKey
 * @param params
 */
const useConsumerPrescriptors = (consumerKey: string, params: ConsumerProductsIndexRequest = {}) => {
    return useSwr(
        `consumers/${consumerKey}/prescriptors`,
        () => consumerProductApi().prescriptors(consumerKey, params)
    );
};

export default useConsumerPrescriptors;
